module.exports = __webpack_public_path__ + "d18056f981a36013e00d1b49ab56c6aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-22.png
// module id = 2287
// module chunks = 0